import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { closePopup } from '../../Modal/action';
import DropDown from '../../dropdown';
import './style.scss';

@connect((state)=>({
}),(dispatch)=>({
    ...bindActionCreators({closePopup},dispatch),
}))
export default class ContinuedInvestor extends Component {

    constructor(props){
        super(props);
        this.state={
            adjusted_nav: this.props.defaultValue,
        }
    }
    handleClick  = () => {
        this.props.closePopup();
        this.props.onChange('adjusted_nav',this.state.adjusted_nav);
    };
    selectChange=(val)=>{
        this.setState({
            adjusted_nav:val
        });
    }
    render() {
         let { closePopup, dropDownValue} = this.props;
        const {adjusted_nav}=this.state;
        return (
            <div className="modal-body clearfix row">
                <p className="subtitle">Select the fund for which you have a continued investment:</p>
                <div className='col-6 form-data nav-dropdown'>
                    <span className='label'></span>
                    {dropDownValue.values && <DropDown dropdownOptions={dropDownValue.values} getValue
                              onSelect={this.selectChange}
                              defaultSelected={adjusted_nav} name='adjusted_nav' />}
                </div>
                <button className='btn-primary' disabled={this.state.adjusted_nav.name=="Select"} onClick={this.handleClick}>
                    SUBMIT</button>
            </div>
        );
    }
}

